export interface QRToggleCustomOption {
  /** Index in viewValues that uses an editable input (0-based). */
  index: number;
  /** Text after the input value, e.g. ' M'. */
  suffix?: string;
  /** Text before the input value. */
  prefix?: string;
  /** Shown when customValue is empty (default: '...'). */
  emptyPlaceholder?: string;
  /** Tooltip shown on hover for the custom segment. */
  tooltip?: string;
  /** Initial value when customValue is unset. */
  defaultValue?: string | number;
  /** Debounce in ms before emitting change for custom input (default: 500). */
  debounceTime?: number;
  min?: number;
  max?: number;
}

export class QRToggle {
  hierarchy!: string;
  size: number = 0;
  viewValues: string[] = [];
  optionSelected: number = 0;
  tooltips?: string[] = [];
  icons?: string[] = [];
  /** Optional: one segment renders as debounced input + suffix. */
  customOption?: QRToggleCustomOption;
  /** Current custom input value (two-way from parent or managed internally). */
  customValue?: string | number;

  // Jerarquía
  public static readonly HIERARCHY_1 = 'hierarchy-1';
  public static readonly HIERARCHY_2 = 'hierarchy-2';
  public static readonly HIERARCHY_3 = 'hierarchy-3';

  // Tamaños
  public static readonly SIZE_MEDIUM = 40;
  public static readonly SIZE_SMALL = 32;
}
